import { $el } from 'src/scripts/utils/utils'
import { BaseComponent } from '../../components/base-component'
import { parseHTML, replaceNodeChildren } from '../../utils/dom'

export class ProductRelatedBlock extends BaseComponent {
  mountComponent() {
    this.loadProducts()
  }

  loadProducts() {
    this.setAttribute('is-loading', '')

    return fetch(this.dataset.url)
      .then(response => response.text())
      .then(text => {
        this.updateByHTML(parseHTML(text))
        this.removeAttribute('is-loading')
      })
      .catch(() => {
        console.log('Error in product recommendations component')
      })
  }

  updateByHTML(html: Document): void {
    const recommendations: ProductRelatedBlock = $el(`#${this.id}`, html)
    replaceNodeChildren(this, recommendations)
    this.toggleAttribute('is-ready', this.hasChildNodes())
  }
}
